import { WidgetThemeStyles } from "../domain_objects/CrossSellSetupResponse";

export const defaultThemeStyles: WidgetThemeStyles = {
  ThemeId: 0,
  OverallResDiaryLogo: 1,
  OverallGeneralBackgroundColour: "#ffffff",
  OverallGeneralTextColour: "#202227",
  OverallGeneralTableReturnNoticeColour: "#f50057",
  OverallGeneralBorderRadius: 5,
  OverallGeneralFont: "Open Sans",
  OverallBookButtonColour: "#007a7a",
  OverallBookButtonFontColour: "#ffffff",
  OverallMessageTextColour: "#202227",
  OverallMessageBackgroundColour: "#f6ecf1",
  BookingSummaryBackgroundColour: "#ffffff",
  BookingSummaryTextColour: "#202227",
  BookingSummaryBorderRadius: 5,
  CalendarBackgroundColour: "#ffffff",
  CalendarBorderColour: "#ffffff",
  CalendarMonthDayTextColour: "#202227",
  CalendarBorderRadius: 5,
  CalendarDayTextColour: "#202227",
  CalendarDayBackgroundColour: "#80bcbc",
  CalendarDayBorderRadius: 0,
  CalendarSelectedTextColour: "#ffffff",
  CalendarSelectedBackgroundColour: "#007a7a",
  PromoBoxBorderColour: "#161616",
  PromoBoxBorderRadius: 5,
  PromoOptionBackgroundColour: "#ffffff",
  PromoOptionTextColour: "#161616",
  PromoOptionHoverBackgroundColour: "#c6c6c6",
  PromoOptionHoverTextColour: "#ececec",
  PromoSelectedBackgroundColour: "#39b34f",
  PromoSelectedTextColour: "#ffffff",
  DropdownGeneralBackgroundColour: "#ffffff",
  DropdownGeneralTextColour: "#202227",
  DropdownGeneralValidationErrorColour: "#d82c0d",
  DropdownGeneralPlaceholderColour: "#202227",
  DropdownBorderColour: "#828d98",
  DropdownBorderFocusColour: "#202227",
  DropdownBorderRadius: 4,
  DropdownSelectedBackgroundColour: "#e9e9e9",
  DropdownSelectedTextColour: "#202227",
  CustomLogoUrl: "",
};
